import type { Canvas } from "fabric";
import { createStore } from "../../../../../../utils/createStore.ts";

export type BaseCanvasState = {
  fabricCanvas: Canvas | undefined;
  isDrawingMode: boolean;
  isDeletionDisabled: boolean;
};

export type BaseCanvasActions = {
  setFabricCanvas: (canvas: Canvas | undefined) => void;
  setIsDrawingMode: (isDrawingMode: boolean) => void;
  setIsDeletionDisabled: (isDeletionDisabled: boolean) => void;
};

export type BaseCanvasStore = ReturnType<typeof createCanvasStore>;

export const createCanvasStore = <TState extends BaseCanvasState, TActions>(
  initialState: TState,
  createAdditionalActions: (utils: {
    get: () => TState;
    setter: <K extends keyof TState>(key: K) => (value: TState[K]) => void;
    set: (partial: Partial<TState>) => void;
  }) => TActions,
) =>
  createStore(initialState, (utils) => {
    const { setter } = utils;

    const baseActions: BaseCanvasActions = {
      setFabricCanvas: setter("fabricCanvas"),
      setIsDrawingMode: setter("isDrawingMode"),
      setIsDeletionDisabled: setter("isDeletionDisabled"),
    };

    const additionalActions =
      createAdditionalActions(utils) ?? ({} as TActions);

    return {
      ...baseActions,
      ...additionalActions,
    } as BaseCanvasActions & TActions;
  });
